import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UsersProfile } from 'src/app/models/users-profile';
import { DataStorageService } from '../../services/data-storage.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { MsalService } from '@azure/msal-angular';
import { DataService } from 'src/app/services/data.service';
import { StateService } from 'src/app/services/state.service';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private currentUserSubject: BehaviorSubject<UsersProfile | null>;
  public currentUser: Observable<UsersProfile | null>;

  public get currentUserValue(): UsersProfile {
    return this.currentUserSubject.value;
  }

  public currentUserObject: any;
  public currentUserRoles: any;
  userDetails: any;
  appUser: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private authService: MsalService,
    private ds: DataService,
    private stateService: StateService,
    private dataStorageService: DataStorageService,
  ) {
    this.currentUserSubject = new BehaviorSubject<UsersProfile>(this.getUserFromLocalStorage());
    this.currentUser = this.currentUserSubject.asObservable();
  //  this.currentUserObject = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUserRoles = [];
    // debugger;
    //  this.getUserRoles().subscribe();

  }

  getUserFromLocalStorage(): UsersProfile {
    let bytes;
    let decryptedValue;
    const userLocalStorage = this.dataStorageService.getLocalStorageByName('currentUser');
    const cryptoInfo = CryptoJS.AES.encrypt(JSON.stringify({ userLocalStorage }), environment.ENCRYPTKEY).toString();
    if (userLocalStorage) {
      bytes = CryptoJS.AES.decrypt(cryptoInfo, environment.ENCRYPTKEY);
      decryptedValue = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedValue;
    }
    return decryptedValue ? decryptedValue : null;
  }

  getUserDetails(): Observable<any> {
    return new Observable((observer) => {
      if (this.authService.instance.getAllAccounts()[0]) {
        this.ds
          .getService<any>(
            environment.BASEURL +
            environment.GETUSERDETAILSBYOID.replace(
              "{oid}",
              this.authService.instance.getAllAccounts()[0].localAccountId
            )
          )
          .subscribe(
            (res) => {
              let decriptdata = this.ds.decrypt(environment.ENCRYPTKEY_DATA, res?.users);
              let parseData = JSON.parse(decriptdata);
              this.currentUserObject = parseData;
              this.setUserToLocalStorage(this.currentUserObject);
              this.getAllDepos(parseData);
              this.getAllUserRoles(parseData);
              this.userDetails = parseData;
              this.appUser.next(parseData);
              this.appUser.complete();
              observer.next(parseData);
              observer.complete();
            },
            (error) => {
              observer.error(error);
              observer.complete;
            }
          );
      }
    });
  }

  getAllDepos(data) {
    for (var i = 0; i < data.smthOrgStructure.length; i++) {
      this.stateService.allDepos.push(data.smthOrgStructure[i].sectionManager);
    }
  }

  getAllUserRoles(data) {
    for (var i = 0; i < data.userRoles.length; i++) {
      this.stateService.userRoles.push(data.userRoles[i].name);
    }
  }

  getUserRoles() {
    return new Observable((observer) => {
      this.currentUserRoles = [];
      if (!this.currentUserObject) {
       
        this.getUserDetails().subscribe(res => {
          this.currentUserObject = res;
          
          if (this.currentUserObject && this.currentUserObject.userRoles) {
            this.currentUserObject.userRoles.forEach(role => {
              this.currentUserRoles.push(role.id);
            });
            observer.next(this.currentUserRoles);
            observer.complete();
          }
        })
      } else {
        if (this.currentUserObject && this.currentUserObject.userRoles) {
          this.currentUserObject.userRoles.forEach(role => {
            this.currentUserRoles.push(role.id);
          });
          observer.next(this.currentUserRoles);
          observer.complete();
        }
      }
    });
  }

  logout() {
    //clear local storage upon log out
    this.dataStorageService.clearLocalStorage();
    this.currentUserSubject.next(null);
  }

  getIsAdmin() {
    return this.currentUserRoles.includes(4);
  }
  getIsReviewTS() {
    return this.currentUserRoles.includes(2);
  }

  getIsAdminGuest() {
    return this.currentUserRoles.includes(3);
  }
  getIsStandardManagement() {
    return this.currentUserRoles.includes(6);
  }

  getIsTrainer() {
    return this.currentUserRoles.includes(7);
  }

  getIsReadOnly() {
    return (this.currentUserRoles.includes(9) && this.currentUserRoles.length == 1);
  }

  getLoggedinUserDetails() {
    return this.currentUserObject;
  }

  setUserToLocalStorage(user) {
    const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(user), environment.ENCRYPTKEY);
    return this.dataStorageService.setLocalStorageByValue('currentUser', encryptedUser);
  }

  getLoggedinUserRoles() {
    return this.currentUserRoles;
  }

  // userType 0 -internal, 1 - external
  getUserAlloedRoles(userType) {
    const allowedActions = [];
    if (this.getIsAdmin()) {
      if (userType === 0) {
        allowedActions.push(
          { roleId: 1, roleName: 'Submit & View Test Slips' },
          { roleId: 2, roleName: 'Review Test Slips' },
          { roleId: 4, roleName: 'Admin' },
        );
      } else {
        allowedActions.push(
          { roleId: 1, roleName: 'Submit & View Test Slips' },
          { roleId: 3, roleName: 'Admin ( Guest)' },
          { roleId: 5, roleName: 'Browse Handbook' }
        );
      }
    }
    if (this.getIsReviewTS()) {
      if (userType === 0) {
        allowedActions.push(
          { roleId: 1, roleName: 'Submit & View Test Slips' },
          { roleId: 2, roleName: 'Review Test Slips' }
        );
      }
    }
    if (this.getIsAdminGuest()) {
      if (userType === 1) {
        allowedActions.push(
          { roleId: 3, roleName: 'Admin ( Guest)' },
          { roleId: 5, roleName: 'Browse Handbook' }
        );
      }
    }
    if (this.getIsStandardManagement()) {
      return [{}];
    }
  }
}
